// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, COMMON_ROOT, transmission, WEB_METHODS } from '../../network/index'
import Vue from 'vue'

const ROOT = '/library'

const state = {
  libraryStr: '|，|',
  libraryCookieKey: 'ckLibSearch',
  libraryKeywords: []
}

const getters = {}

const mutations = {
  setLibraryKeywords (state, keyword = null) {
    const str = state.libraryStr
    let cookies = Vue.$cookies.get(state.libraryCookieKey)
    let keywords = []
    if (cookies) {
      keywords = cookies.split(str, 9)
      if (keyword) {
        for(let i = 0; i < keywords.length; i++) {
          if (keywords[i] === keyword) {
            keywords.splice(i, 1)
          }
        }
        keywords.unshift(keyword)
      }
    } else {
      if (keyword) {
        keywords = [keyword]
      }
    }
    cookies = keywords.join(str)
    Vue.$cookies.set(state.libraryCookieKey, cookies)
    state.libraryKeywords = keywords
  },
  delLibraryKeywords (state, index) {
    const str = state.libraryStr
    let cookies = ''
    let keywords = []
    if (index !== null) {
      keywords = state.libraryKeywords
      keywords.splice(index, 1)
      cookies = keywords.join(str)
    }
    Vue.$cookies.set(state.libraryCookieKey, cookies)
    state.libraryKeywords = keywords
  }
}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 사용자 > 도서관 > 도서관목록조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getLibraryList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/librarys`, payload)
  },

  /**
     * 사용자 > 도서관 > 검색 > 도서관 목록조회 Api
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line no-unused-vars
    async getSearchLibraryList ({commit}, payload) {
      return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/search`, payload)
    },

  /**
   * 사용자 > 도서관 > 신규도서관목록조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getNewLibraryList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/new-librarys`, payload)
  },

  /**
   * 사용자 > 도서관 > 도서관목록 상세 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getLibraryDetailOne ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/librarys/{libNo}`, payload)
  },

  /**
   * 사용자 > 도서관 > 도서관목록 상세 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setInqCount ({commit}, payload) {
    return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/library-inqs/{libNo}`, payload)
  },

  /**
   * 사용자 > 도서관 > 도서관 좋아요 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setLibraryLike ({commit}, payload) {
    return transmission(true, WEB_METHODS.PUT, `${USER_ROOT + ROOT}/library-likes/{libNo}`, payload)
  },

  /**
   * 사용자 > 도서관 > 도서관좋아요목록조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getLibraryLikeList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/library-likes`, payload)
  },

  /**
   * 사용자 > 도서관 > 추천콘텐츠 도서관 목록조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getRecommendedLibList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/recommend-librarys`, payload)
  },
  /**
  * 사용자 > 도서관 > 도서관 추천 콘텐츠 상세조회 Api
  * @param commit
  * @param payload
  * @returns {Promise<unknown>}
  */
  // eslint-disable-next-line no-unused-vars
  async getRecommendedLibDetail ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/recommend-librarys/{recomContentsId}`, payload)
  },
}

export default { state, getters, mutations, actions }
